import React from 'react';
import { CheckCircle, AlertCircle, AlertTriangle, Info, X } from 'lucide-react';
import useNotificationStore from '../store/useNotificationStore';

const Notification = () => {
  const { notification, clearNotification } = useNotificationStore();

  if (!notification) return null;

  const { type, message } = notification;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle className='w-5 h-5' />;
      case 'error':
        return <AlertCircle className='w-5 h-5' />;
      case 'warning':
        return <AlertTriangle className='w-5 h-5' />;
      case 'info':
        return <Info className='w-5 h-5' />;
      default:
        return <Info className='w-5 h-5' />;
    }
  };

  const getBackgroundColor = () => {
    switch (type) {
      case 'success':
        return 'bg-green-500 text-white';
      case 'error':
        return 'bg-red-500 text-white';
      case 'warning':
        return 'bg-yellow-500 text-white';
      case 'info':
        return 'bg-blue-500 text-white';
      default:
        return 'bg-gray-500 text-white';
    }
  };

  return (
    <div className='fixed top-4 left-1/2 transform -translate-x-1/2 z-[9999] animate-slide-down'>
      <div
        className={`px-6 py-3 rounded-lg shadow-lg flex items-center gap-3 min-w-[300px] ${getBackgroundColor()}`}
      >
        {getIcon()}
        <span className='font-medium flex-1'>{message}</span>
        <button
          onClick={clearNotification}
          className='hover:opacity-80 transition-opacity'
          aria-label='Close notification'
        >
          <X className='w-4 h-4' />
        </button>
      </div>
    </div>
  );
};

export default Notification;
